import { NavLink } from 'react-router-dom';
import { IconCalendarEvent, IconInfoCircle, IconUser } from '@tabler/icons-react';
import { track } from '../../utils/analytics';
import './BottomNav.scss';

const tabs = [
    { to: '/subscriptions', label: 'Подписки', end: true, Icon: IconCalendarEvent },
    { to: '/account', label: 'Аккаунт', Icon: IconUser },
    { to: '/links', label: 'Ещё', Icon: IconInfoCircle },
];

export default function BottomNav() {
    return (
        <nav className="bottom-nav">
            {tabs.map((tab) => (
                <NavLink
                    key={tab.to}
                    to={tab.to}
                    end={tab.end}
                    onClick={() => track('nav_click', { target: tab.to })}
                    className={({ isActive }) =>
                        `bottom-nav__item${isActive ? ' bottom-nav__item--active' : ''}`
                    }
                >
                    <tab.Icon size={20} stroke={1.5} />
                    {tab.label}
                </NavLink>
            ))}
        </nav>
    );
}
